export class PaymentRequestCodingEditorParamterDto {
    communityId: number;
    bankAccountId: number;
    payeeCode: string;

    getQueryString(): string {
        let url = `?payeeCode=${this.payeeCode}`;

        if (this.bankAccountId) {
            url += `&bankAccountId=${this.bankAccountId}`;
        }
        if (this.communityId) {
            url += `&communityId=${this.communityId}`;
        }

        return url;
    }
}
